import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { usePmsDocumentType, PmsDocumentType } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => (
  <GenericFormPage<PmsDocumentType>
    useData={usePmsDocumentType}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
    }}
  />
);

export default Form;
